export const CLONES_CARS_PER_PAGE = 5;

export const CARS_SUBSCRIPTION_PER_PAGE = 3;
